// Libraries
import HeaderLayout from '../HeaderLayout';
import { Sidebar } from '../../components';
import React from 'react';
import PropTypes from 'prop-types';

// Layouts

// Styles
import './sidebarLayout.scss';

const SidebarLayout = ({ children }) => (
    <HeaderLayout>
        <Sidebar />
        <div className="sidebarlayout-content">{children}</div>
    </HeaderLayout>
);

SidebarLayout.propTypes = {
    children: PropTypes.node.isRequired,
};

export default SidebarLayout;
